import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 11.871C0 5.37017 5.45242 -0.00894806 12.0358 1.11754e-05C18.5565 1.11754e-05 23.9892 5.39884 24 11.8692C24.0125 18.7391 18.8021 23.9964 11.991 24C5.17998 24.0036 0 18.7696 0 11.871ZM11.9641 21.0094C16.8287 21.0345 20.944 17.0763 20.9709 12.3494C20.9995 7.03838 17.2176 3.09453 12.0735 3.07303C6.96698 3.05153 3.15459 6.86995 3.02375 11.9265C2.90366 16.5907 6.86482 21.0972 11.9641 21.0058V21.0094Z"
      fill="#DBA165"
    />
    <path
      d="M11.9322 16.6673C10.6202 16.6673 9.30814 16.6816 7.99791 16.6673C6.97984 16.653 6.38477 16.0778 6.38477 15.1622C6.38477 14.2465 6.99597 13.6427 7.99791 13.6355C10.6793 13.6176 13.3613 13.6176 16.0439 13.6355C17.0423 13.6355 17.6051 14.2501 17.5907 15.1944C17.5782 16.0993 17.0351 16.6458 16.0547 16.6637C14.6727 16.6924 13.3016 16.6673 11.9322 16.6673Z"
      fill="#DBA165"
    />
    <path
      d="M8.87525 10.5504C8.48535 10.5445 8.11195 10.3921 7.82932 10.1235C7.5467 9.85492 7.37556 9.48982 7.34994 9.10082C7.33465 8.90051 7.36087 8.69921 7.42695 8.50949C7.49303 8.31977 7.59756 8.14572 7.73399 7.99823C7.87042 7.85074 8.03583 7.73297 8.21987 7.6523C8.4039 7.57162 8.60261 7.52978 8.80356 7.52937C9.19358 7.52549 9.57051 7.66991 9.85803 7.9334C10.1456 8.19688 10.3222 8.55974 10.3522 8.94851C10.356 9.35323 10.2053 9.74418 9.93095 10.0418C9.65657 10.3394 9.27905 10.5213 8.87525 10.5504Z"
      fill="#DBA165"
    />
    <path
      d="M14.7724 7.52914C14.9666 7.51952 15.1607 7.54861 15.3436 7.61471C15.5264 7.68081 15.6943 7.78261 15.8374 7.91417C15.9805 8.04574 16.096 8.20444 16.1772 8.38105C16.2584 8.55767 16.3036 8.74865 16.3103 8.94291C16.3246 9.34978 16.1793 9.74613 15.9053 10.0474C15.6314 10.3487 15.2506 10.531 14.8441 10.5556C14.0554 10.5753 13.2722 9.81016 13.2793 9.02175C13.2985 8.63206 13.4619 8.26341 13.7379 7.98752C14.0138 7.71164 14.3826 7.54825 14.7724 7.52914Z"
      fill="#DBA165"
    />
  </svg>
);
const IconNeutral = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconNeutral;
